import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { Link, useRoute } from "wouter";
import { cn } from "@/utils/classes";

/* Variants */
const variants = cva("flex flex-row gap-2 p-2 btn btn-ghost items-center justify-start text-sm min-h-10 h-10 max-h-10 rounded-lg", {
  variants: {
    active: {
      true: "bg-base-200",
      false: "",
    },
    selected: {
      true: "bg-primary text-white",
      false: "",
    },
    disabled: {
      true: "btn-disabled ",
      false: "",
    },
  },
  defaultVariants: {
    active: false,
    disabled: false,
  },
});

/* Prop Types */
export interface NavLinkProps extends VariantProps<typeof variants> {
  href: string;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

/*
 * NavLink component
 */
export const NavLink = ({ href, disabled, className, children, selected, onClick }: NavLinkProps) => {
  const [isActive] = useRoute(href);
  return (
    <Link href={href} onClick={onClick} className={cn(variants({ active: isActive, className, disabled, selected }))}>
      {children}
    </Link>
  );
};
